// app-user · account extras (sign-in, language, theme, reviews, claims, messages) — routes
// the design reserved but did not draw ("Not designed"). Spread into en.ts / bn.ts.
export const appEnExtras = {
  'app.extras.tagline': 'Tap • Book • Go',
  'app.extras.langTitle': 'Language',
  'app.extras.langNote': 'Applies to the whole app. Business names and reviews stay in the language they were written in.',
  'app.extras.themeTitle': 'Theme',
  'app.extras.themeLightSub': 'Bright background',
  'app.extras.themeDarkSub': 'Easier on the eyes at night',
  'app.extras.themeNote': 'Saved on this device and on your account.',
  'app.extras.syncFail': 'Saved on this phone. We could not update your account just now.',
  'app.extras.offlineAction': 'You are offline. Connect to do this.',
  'app.extras.loadFailed': 'Could not load this',
  'app.extras.loadFailedBody': 'Check your connection and try again.',
  'app.extras.claims.title': 'Problems I reported',
  'app.extras.claims.emptyTitle': 'No problems reported',
  'app.extras.claims.emptyBody': 'If something goes wrong with a booking, report it from the booking and follow it here.',
  'app.extras.claims.kind.paid_but_rejected': 'Paid but not accepted',
  'app.extras.claims.kind.complaint': 'Complaint',
  'app.extras.claims.kind.refund_claim': 'Refund request',
  'app.extras.claims.kind.no_service': 'Service not received',
  'app.extras.claims.kind.no_show': 'No-show refund',
  'app.extras.claims.kind.other': 'Other',
  'app.extras.claims.status.open': 'Under review',
  'app.extras.claims.status.escalated': 'Escalated',
  'app.extras.claims.status.resolved': 'Resolved',
  'app.extras.claims.resolution.override_confirmed': 'Booking confirmed',
  'app.extras.claims.resolution.refund_recorded': 'Refund recorded',
  'app.extras.claims.resolution.uphold_merchant': 'Business decision upheld',
  'app.extras.claims.resolution.warn_customer': 'Closed with a note',
  'app.extras.claims.resolution.penalty_merchant': 'Resolved in your favour',
  'app.extras.claims.resolution.block_customer': 'Closed',
  'app.extras.claims.resolution.dismissed': 'Dismissed',
  'app.extras.claims.resolution.other': 'Decided',
  'app.extras.claims.decision': 'Decision',
  'app.extras.claims.slaHours': '{n} h',
  'app.extras.claims.yourReport': 'What you told us',
  'app.extras.claims.booking': 'Booking {code}',
  'app.extras.claims.reopened': 'Reopened {when}',
  'app.extras.claims.viewBooking': 'View booking',
  'app.extras.claims.refund': 'Refund {amount} · {status}',
  'app.extras.claims.refundPending': 'pending',
  'app.extras.claims.refundPaid': 'paid',
  'app.extras.claims.refundDeclined': 'declined',
  'app.extras.claims.businessTitle': 'Business claims',
  'app.extras.claims.businessWithdrawn': 'Claim withdrawn',
  'app.extras.claims.rejectReason': 'Reason: {reason}',
  'app.extras.claims.filedOn': 'Filed {when}',
  'app.extras.msg.menu': 'Conversation options',
  'app.extras.msg.report': 'Report conversation',
  'app.extras.msg.block': 'Block',
  'app.extras.msg.reportTitle': 'Report this conversation',
  'app.extras.msg.reason.spam': 'Spam or ads',
  'app.extras.msg.reason.abusive': 'Abusive language',
  'app.extras.msg.reason.scam': 'Looks like a scam',
  'app.extras.msg.reason.other': 'Other',
  'app.extras.signIn.title': 'Sign in',
  'app.extras.signIn.phoneBody': 'Enter your phone number. We will text you a 6-digit code.',
  'app.extras.signIn.phoneLabel': 'Phone number',
  'app.extras.signIn.sendCode': 'Send code',
  'app.extras.signIn.codeBody': 'Enter the 6-digit code sent to {phone}',
  'app.extras.signIn.verify': 'Verify and continue',
  'app.extras.signIn.resend': 'Resend code',
  'app.extras.signIn.resendIn': 'Resend in {time}',
  'app.extras.signIn.resendLimit': 'Too many codes sent. Try again in a few minutes.',
  'app.extras.signIn.errWrong': 'That code is not right. Check the SMS and try again.',
  'app.extras.signIn.errLocked': 'Too many wrong tries. Request a new code.',
  'app.extras.signIn.errRate': 'Too many requests. Please wait a minute and try again.',
  'app.extras.signIn.errSend': 'We could not send the code. Check your connection and try again.',
  'app.extras.signIn.errVerify': 'We could not verify the code. Try again.',
  'app.extras.signIn.offline': 'You are offline. Connect to sign in.',
  'app.extras.signIn.terms': 'By continuing you agree to the Terms and Privacy Policy.',
  'app.extras.gateB': 'Your reviews, reports and messages are tied to your phone number.',
  'app.extras.gateCta': 'Sign in',
  'app.extras.reviews.gateT': 'Sign in to see your reviews',
  'app.extras.reviews.rateT': 'How was your visit?',
  'app.extras.claims.gateT': 'Sign in to see your reports',
  'app.extras.claims.msgEscalated': 'Passed to our team for a closer look.',
  'app.extras.claims.openN': '{n} open',
  'app.extras.msg.gateT': 'Sign in to see your messages',
  'app.extras.themeNoteDevice': 'Saved on this phone.',
} as const satisfies Record<string, string>;

export const appBnExtras = {
  'app.extras.tagline': 'ট্যাপ করুন • বুক করুন • চলে যান',
  'app.extras.langTitle': 'ভাষা',
  'app.extras.langNote': 'পুরো অ্যাপে প্রযোজ্য। ব্যবসার নাম ও রিভিউ যে ভাষায় লেখা, সেভাবেই থাকবে।',
  'app.extras.themeTitle': 'থিম',
  'app.extras.themeLightSub': 'উজ্জ্বল ব্যাকগ্রাউন্ড',
  'app.extras.themeDarkSub': 'রাতে চোখের জন্য আরামদায়ক',
  'app.extras.themeNote': 'এই ফোনে ও আপনার অ্যাকাউন্টে সেভ হয়।',
  'app.extras.syncFail': 'এই ফোনে সেভ হয়েছে। এখন অ্যাকাউন্ট আপডেট করা যায়নি।',
  'app.extras.offlineAction': 'আপনি অফলাইন। এটি করতে ইন্টারনেটে যুক্ত হোন।',
  'app.extras.loadFailed': 'লোড করা যায়নি',
  'app.extras.loadFailedBody': 'সংযোগ দেখে আবার চেষ্টা করুন।',
  'app.extras.claims.title': 'আমার জানানো সমস্যা',
  'app.extras.claims.emptyTitle': 'কোনো সমস্যা জানানো হয়নি',
  'app.extras.claims.emptyBody': 'বুকিংয়ে কিছু ঠিকমতো না হলে বুকিং থেকে জানান, এখানে অগ্রগতি দেখুন।',
  'app.extras.claims.kind.paid_but_rejected': 'টাকা দিয়েছি কিন্তু গ্রহণ হয়নি',
  'app.extras.claims.kind.complaint': 'অভিযোগ',
  'app.extras.claims.kind.refund_claim': 'ফেরতের অনুরোধ',
  'app.extras.claims.kind.no_service': 'সার্ভিস পাইনি',
  'app.extras.claims.kind.no_show': 'নো-শো ফেরত',
  'app.extras.claims.kind.other': 'অন্যান্য',
  'app.extras.claims.status.open': 'পর্যালোচনায়',
  'app.extras.claims.status.escalated': 'উচ্চ পর্যায়ে',
  'app.extras.claims.status.resolved': 'নিষ্পন্ন',
  'app.extras.claims.resolution.override_confirmed': 'বুকিং নিশ্চিত হয়েছে',
  'app.extras.claims.resolution.refund_recorded': 'ফেরত নথিভুক্ত হয়েছে',
  'app.extras.claims.resolution.uphold_merchant': 'ব্যবসার সিদ্ধান্তই বহাল',
  'app.extras.claims.resolution.warn_customer': 'নোটসহ বন্ধ করা হয়েছে',
  'app.extras.claims.resolution.penalty_merchant': 'আপনার পক্ষে নিষ্পত্তি',
  'app.extras.claims.resolution.block_customer': 'বন্ধ করা হয়েছে',
  'app.extras.claims.resolution.dismissed': 'খারিজ',
  'app.extras.claims.resolution.other': 'সিদ্ধান্ত হয়েছে',
  'app.extras.claims.decision': 'সিদ্ধান্ত',
  'app.extras.claims.slaHours': '{n} ঘণ্টা',
  'app.extras.claims.yourReport': 'আপনি যা জানিয়েছেন',
  'app.extras.claims.booking': 'বুকিং {code}',
  'app.extras.claims.reopened': '{when} আবার খোলা হয়েছে',
  'app.extras.claims.viewBooking': 'বুকিং দেখুন',
  'app.extras.claims.refund': 'ফেরত {amount} · {status}',
  'app.extras.claims.refundPending': 'অপেক্ষমাণ',
  'app.extras.claims.refundPaid': 'পরিশোধিত',
  'app.extras.claims.refundDeclined': 'প্রত্যাখ্যাত',
  'app.extras.claims.businessTitle': 'ব্যবসার দাবি',
  'app.extras.claims.businessWithdrawn': 'দাবি প্রত্যাহার করা হয়েছে',
  'app.extras.claims.rejectReason': 'কারণ: {reason}',
  'app.extras.claims.filedOn': 'জমা দেওয়া {when}',
  'app.extras.msg.menu': 'কথোপকথনের অপশন',
  'app.extras.msg.report': 'কথোপকথন রিপোর্ট করুন',
  'app.extras.msg.block': 'ব্লক করুন',
  'app.extras.msg.reportTitle': 'এই কথোপকথন রিপোর্ট করুন',
  'app.extras.msg.reason.spam': 'স্প্যাম বা বিজ্ঞাপন',
  'app.extras.msg.reason.abusive': 'অশালীন ভাষা',
  'app.extras.msg.reason.scam': 'প্রতারণা মনে হচ্ছে',
  'app.extras.msg.reason.other': 'অন্যান্য',
  'app.extras.signIn.title': 'সাইন ইন',
  'app.extras.signIn.phoneBody': 'আপনার ফোন নম্বর দিন। আমরা ৬ সংখ্যার একটি কোড এসএমএস করব।',
  'app.extras.signIn.phoneLabel': 'ফোন নম্বর',
  'app.extras.signIn.sendCode': 'কোড পাঠান',
  'app.extras.signIn.codeBody': '{phone} নম্বরে পাঠানো ৬ সংখ্যার কোড দিন',
  'app.extras.signIn.verify': 'যাচাই করে এগিয়ে যান',
  'app.extras.signIn.resend': 'আবার কোড পাঠান',
  'app.extras.signIn.resendIn': 'আবার পাঠান {time}-এ',
  'app.extras.signIn.resendLimit': 'অনেকবার কোড পাঠানো হয়েছে। কয়েক মিনিট পরে চেষ্টা করুন।',
  'app.extras.signIn.errWrong': 'কোডটি ঠিক নয়। এসএমএস দেখে আবার চেষ্টা করুন।',
  'app.extras.signIn.errLocked': 'অনেকবার ভুল হয়েছে। নতুন কোড চান।',
  'app.extras.signIn.errRate': 'অনেক অনুরোধ হয়েছে। এক মিনিট অপেক্ষা করে আবার চেষ্টা করুন।',
  'app.extras.signIn.errSend': 'কোড পাঠানো যায়নি। সংযোগ দেখে আবার চেষ্টা করুন।',
  'app.extras.signIn.errVerify': 'কোড যাচাই করা যায়নি। আবার চেষ্টা করুন।',
  'app.extras.signIn.offline': 'আপনি অফলাইন। সাইন ইন করতে ইন্টারনেটে যুক্ত হোন।',
  'app.extras.signIn.terms': 'এগিয়ে গেলে আপনি শর্তাবলি ও গোপনীয়তা নীতিতে সম্মত হচ্ছেন।',
  'app.extras.gateB': 'আপনার রিভিউ, জানানো সমস্যা ও মেসেজ আপনার ফোন নম্বরের সাথে যুক্ত।',
  'app.extras.gateCta': 'সাইন ইন',
  'app.extras.reviews.gateT': 'রিভিউ দেখতে সাইন ইন করুন',
  'app.extras.reviews.rateT': 'আপনার অভিজ্ঞতা কেমন ছিল?',
  'app.extras.claims.gateT': 'জানানো সমস্যা দেখতে সাইন ইন করুন',
  'app.extras.claims.msgEscalated': 'আরও ভালোভাবে দেখতে আমাদের টিমের কাছে পাঠানো হয়েছে।',
  'app.extras.claims.openN': '{n}টি খোলা',
  'app.extras.msg.gateT': 'মেসেজ দেখতে সাইন ইন করুন',
  'app.extras.themeNoteDevice': 'এই ফোনে সেভ হয়।',
} as const satisfies Record<string, string>;
